// extracted by mini-css-extract-plugin
export default {"audio":"audio-player_audio__hn+pL","playPauseButton":"audio-player_playPauseButton__Rfs-A","seek":"audio-player_seek__8IYmr","volume":"audio-player_volume__GZefg"};